// import styled, { css } from 'styled-components';

// export const InputField = styled.input`
//   width: 100%;
//   box-sizing: border-box;
//   outline: none;
//   border: none;
//   background-color: inherit;
//   // color: #fff;
//   padding: 0;
//   font-size: 18px;
//   font-weight: 900;
//   margin: 4px 0px;
//   font-family: 'DM Sans';
//   border: 1px solid #fff;
//   background-color: #fff;
//   padding: 8px 16px;
//   color: #000;
//   :focus {
//     background: white;
//   }

// `;

// export const InputFieldDetails = styled.div`
//   width: 100%;
//   box-sizing: border-box;
//   background-color: inherit;
//   // color: #fff;
//   padding: 0;
//   font-size: 18px;
//   margin: 4px 0px;
//   font-family: 'DM Sans';
// `;
// export const InputLabel = styled.label`
//   display: block;
//   font-size: 14px;
//   margin-top: 4px;
// `;
// export const InputContainer = styled.div`
//   // background-color: #212121;
//   //border: 1px solid #00000080;
//   box-sizing: border-box;
//   // color: #fff;
//   // padding: 10px 5px;
//   border-radius: 8px;
//   // border-bottom: 1px solid #00000029;
//   ${(props) =>
//     props.error &&
//     css`
//       border: 1px solid red;
//       border-radius: 5px
//     `}
// `;

// export const InputError = styled.div`
//   font-size: 14px;
//   margin-top: 4px;
//   color: red;
// `;

// export const Flex = styled.div`
//   display: flex;
//   justify-content: ${(props) => props.justifyContent};
//   align-items: ${(props) => props.alignItems};
// `;

// export const ApplicationRootStyles = styled.div`
//   height: 100%;
//   width: 100%;
//   // background-color: #1b1b1b;
//   // display: flex;
//   // justify-content: center;
//   // align-items: center;
//   // background-image: url("http://casino.tecpiniondev.com/images/account/casino-bg.jpg");
//   background-repeat: no-repeat;
//   background-size: cover;
//   // box-shadow: rgb(32 32 32 / 55%) 0px 0px 0px 2000px inset;
//   .base-form { 
//     width: 480px;
//     background-color: #000000c7;
//     padding-bottom: 1rem;
//     font-family: "Open Sans",sans-serif;
//     margin: 0 auto;
//     color: #fff;
//     border-radius: 6px;
//     height: 390px;
//     position: relative;
//   }
// `;

// export const Button = styled.button`
// box-sizing: border-box;
// padding: 7px 60px;
// font-size: 20px;
// font-family: 'DM Sans';
// outline: none;
// border: none;
// cursor: pointer;
// color: #fff;
// border-radius: 0px;
// width: 100%;
// background-color: #3cb37100; 
// display: -webkit-box;
// display: -webkit-flex;
// display: -ms-flexbox;
// display: flex;
// -webkit-align-items: center;
// -webkit-box-align: center;
// -ms-flex-align: center;
// align-items: center;
// -webkit-box-pack: center;
// -webkit-justify-content: center;
// -ms-flex-pack: center;
// justify-content: center;
// border: 1px solid #fff;
// margin-bottom: 15px;

//   :hover {
//     background-color: #3cb371;
//   }
//   :active {
//     background-color: #009cad;
//   }

//   ${(props) =>
//     props.secondary &&
//     css`
//       background-color: unset;
//       border: 1px solid #fff;
//       :hover,
//       :active {
//         background-color: unset;
//       }
//     `}
// `;








import styled, { css } from 'styled-components';

export const InputField = styled.input`
     width: 100%;
    box-sizing: border-box;
    outline: none;
    border: none;
    background-color: inherit;
    padding: 0;
    font-size: 16px;
    font-weight: 400;
    /* border: 1px solid #fff; */
    background-color: #212121;
    padding: 10px 15px;
    color: #DEDEDE !important;
    border-radius: 20px;
  :focus {
    background: white;
  }

`;

export const InputFieldDetails = styled.div`
  width: 100%;
  box-sizing: border-box;
  background-color: inherit;
  // color: #fff;
  padding: 0;
  font-size: 18px;
  margin: 4px 0px;
  ${'' /* font-family: 'DM Sans'; */}
`;
export const InputLabel = styled.label`
  display: block;
  font-size: 14px;
  ${'' /* margin-top: 4px; */}
  margin-bottom: 4px;
`;
export const InputContainer = styled.div`
  // background-color: #212121;
  //border: 1px solid #00000080;
  box-sizing: border-box;
  // color: #fff;
  // padding: 10px 5px;
  border-radius: 8px;
  // border-bottom: 1px solid #00000029;
  ${(props) =>
    props.error &&
    css`
      ${'' /* border: 1px solid red; */}
      border-radius: 5px
    `}
`;

export const InputError = styled.div`
  font-size: 14px;
  margin-top: 4px;
  color: red;
  
`;

export const Flex = styled.div`
  display: flex;
  justify-content: ${(props) => props.justifyContent};
  align-items: ${(props) => props.alignItems};
`;

export const ApplicationRootStyles = styled.div`
  height: 100%;
  width: 100%;
  // background-color: #1b1b1b;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  // background-image: url("http://casino.tecpiniondev.com/images/account/casino-bg.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  // box-shadow: rgb(32 32 32 / 55%) 0px 0px 0px 2000px inset;
  .base-form {
    height: 750px;
    width: 700px;
  
  
    padding-bottom: 1rem;
    // font-family: "Open Sans",sans-serif;
    margin: 0 auto;
    color: #fff;
    border-radius: 6px;
    ${'' /* height: 390px; */}
    position: relative;
  }
  .base-form.base-form2 {
    height: 750px;
  }
`;
export const Button = styled.button`
box-sizing: border-box;
    padding: 10px 10px;
    font-size: 16px;
    outline: none;
    border: none;
    cursor: pointer;
    color: #fff;
    border-radius: 20px;
    width: 40%;
    background-color: #F5048D;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex
    
;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    /* border: 1px solid #fff; */
    margin-bottom: 15px;
    margin-top: 10px;

  ${(props) =>
    props.secondary &&
    css`
      background-color: unset;
      border: 1px solid #fff;
      :hover,
      :active {
        background-color: unset;
      }
    `}
`;

